import useLegacySelection from "../hooks/useSelection";
import { PricelistItem, RootProduct } from "./formatters";

const emptyPrice: PricelistItem = {
  price: "",
  priceAsNumber: 0,
  priceBeforeDiscount: "",
  priceBeforeDiscountAsNumber: 0,
  discountPercent: 0,
  showAsOnSale: false,
};

export const getPriceList = (
  prices: RootProduct["pricelist"] | undefined,
  priceList: number | string | undefined
): PricelistItem => {
  if (!prices) return emptyPrice;
  if (typeof priceList === "string") priceList = parseInt(priceList);
  if (Array.isArray(prices)) {
    return (
      prices.find((price) => price.pricelistId === String(priceList)) ||
      emptyPrice
    );
  }

  return prices[priceList || "23"] || prices[String(priceList)] || emptyPrice;
};

const usePriceList = (prices?: RootProduct["pricelist"]) => {
  const { cart } = useLegacySelection();
  const price = getPriceList(prices, cart.priceList);

  return price;
};

export default usePriceList;
